// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MeterPercentSettings_wrapper__2dYOC","iconButton":"MeterPercentSettings_iconButton__T77p9","link":"MeterPercentSettings_link__8X4Cy"};